import {api} from './api'

export const generateIdCard  = async (formData) => {
  return await api.post("idcard/generate", formData, {});
};
export const IdCardList  = async (type) => {
  return await api.get(`idcard/list?type=${type}`,);
};

export const fectchIdCard = async (addUrl = '')=>{
  let url = `idcard/student?${addUrl}`
    return await api.get(url)
}
export const staffIdCard = async (addUrl = '')=>{
  let url = `idcard/staff?${addUrl}`
    return await api.get(url)
}

export const staffIdCardV2 = async (addUrl = '')=>{
  let url = `idcard/staff/v2?${addUrl}`
    return await api.get(url)
}



export const IdCardStatus = async (addUrl = '') =>{
  let url = `/idcard/status${addUrl}`
  return await api.get(url)
}


//Id card v3 api 

export const fectchIdCardV2 = async (addUrl = '')=>{
  let url = `idcard/student/v2?${addUrl}`
    return await api.get(url)
}